import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import api from '@/shared/api';
import config from '@/config';
import { getRelationNameMapper } from '@/shared/components/RelationName';
import { useIntl } from 'react-intl';
import RelationSearch from '@/shared/components/input/RelationSearch';
import EditableToggle from './EditableToggle';
const EditableRelationSearch = ({ onChange, value, crmTypes, readOnly = false, }) => {
    const intl = useIntl();
    const [displayName, setDisplayName] = useState('');
    useEffect(() => {
        if (!value) {
            setDisplayName('');
            return;
        }
        const nameMapper = getRelationNameMapper(intl);
        api.base
            .post(`${config.appUrls.api}/api/relation/names`, [value])
            .then(({ data }) => {
            if (data === null || data === void 0 ? void 0 : data[0]) {
                setDisplayName(nameMapper(data[0]));
            }
        })
            .catch(() => { });
    }, [value, intl]);
    const initialItem = value ? { key: value, label: displayName || undefined } : null;
    return (_jsx(EditableToggle, Object.assign({ onSubmit: (selected) => { var _a, _b; return onChange((_b = (_a = selected === null || selected === void 0 ? void 0 : selected.id) !== null && _a !== void 0 ? _a : selected === null || selected === void 0 ? void 0 : selected.key) !== null && _b !== void 0 ? _b : null); }, value: value, readOnly: readOnly, displayValue: displayName ? (_jsx("span", { children: displayName })) : (_jsx("i", { className: "glyphicon glyphicon-pencil" })) }, { children: ({ setInputValue, submit }) => (_jsx(OutsideClickHandler, Object.assign({ onOutsideClick: submit }, { children: _jsx(RelationSearch, { initialSelectedItem: initialItem, onChange: (relation) => {
                    setInputValue(relation).then(submit);
                }, crmTypes: crmTypes, small: true }) }))) })));
};
export default EditableRelationSearch;
